<template>
  <div class="jps-validation-form">
    <ValidationField
      v-for="ruleField in shownFields"
      :key="ruleField.field"
      :rule="rule"
      :rule-field="ruleField"
      :target="target"
      :simple="simple"
      @valid-change="checkValidity"
      :validation="validation"
      :ref="ruleField.field"
      :lang="lang"
      :disabled="isDisabled(ruleField.field)"
    />
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>

interface Props {
  rule: ValidationRule,
  target: any,
  simple?: boolean,
  only?: string,
  except?: string,
  disabled?: string,
  lang?: any
}
const props = withDefaults(defineProps<Props>(), {})
const emits = defineEmits(['valid'])

const validation:Ref<any> = ref({})

const shownFields = computed(() => {
  if (props.only) {
    return props.only.split(',').map((key) => props.rule.fields[key])
  }
  let excepts = props.except ? props.except.split(',') : []
  return Object.keys(props.rule.fields)
    .filter((key) => !excepts.includes(key))
    .map((key) => props.rule.fields[key])
})

onMounted(() => {
  checkValidity()
})

const isDisabled = (field: string): boolean => {
  if (props.disabled) {
    return props.disabled.split(',').includes(field)
  } else {
    return false
  }
}

const checkValidity = () => {
  let isAllValid = shownFields.value.every((f) => validation.value[f.field])
  emits('valid', isAllValid)
}
// モーダルなどで複数回フィールドが使いまわされる時のみ利用する
defineExpose({ checkValidity })
</script>

<style lang="scss" scoped>
.jps-validation-form {
  margin: 1rem;
}
</style>
